<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/acknowledgement">Acknowledgements</a></p>
<p class="toc"><a href="#/introduction">Introduction</a></p>
<p class="toc1"><a href="#/chapter01">Chapter One: Special Events</a></p>
<p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Chapter Two: The Early Farmhouse</span></p>
<p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Chapter Three: Springtime in the Country</span></p>
<p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Chapter Four: Village Memories</span></p>
<p class="toc1"><span href="#/bibliography" title="Link target outside of Sample">Selected Bibliography</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?46cc31f4